// extracted by mini-css-extract-plugin
export var fadeInOut = "_1a-3";
export var icon = "_1a-4";
export var savedIndicator = "_1a-2";
export var savingIndicator = "_1a-0";
export var spin = "_1a-1";